<template>
  <div class="tiles-card">
    <!-- Tiles -->
    <div v-if="healthTileKeys && Array.isArray(healthTileKeys)">
      <tile
        v-for="(aTileKey, j) in healthTileKeys"
        :profile="profile"
        :heartbeat="heartbeat"
        :tile-key="aTileKey"
        :tile-data="healthTilesDataTiles[aTileKey]"
        :tile-entries="tileEntries"
        @tile-click-for-key="handleAddUpdateTileModal(aTileKey)"
        :key="`tile-${j}`"
      />
      <b-button
        v-b-tooltip="addToolTip"
        @click="handleAddUpdateTileModal(null)"
        variant="outline-primary"
        :style="`height:${dimension}px;width:${dimension}px; margin: 10px`"
      >
        <b-icon icon="plus" aria-hidden="true" scale="4" />
      </b-button>
      <tile-modal
        :modal-id="addTileModalId"
        :profile="profile"
        :heartbeat="heartbeat"
        :tile-key="selectedTileKey"
        :category-entries="categoryEntries"
        :tile-entries="tileEntries"
        @tile-added="handleTileAddedOrUpdated"
      />
    </div>
    <div v-else>
      Skeleton
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import tilesJSON from "@/assets/heartbeat/tiles.json";
import Tile from "@/components/heartbeat/tile";
import TileModal from "@/components/heartbeat/tileModal";
export default {
  name: "HeartBeat_TilesCard",
  components: {
    Tile,
    TileModal
  },
  props: {
    profile: {
      type: Object,
      default: () => {
        return {};
      }
    },
    heartbeat: {
      type: Object,
      default: () => {
        return {};
      }
    },
    heartbeatInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  created() {
    this.getTiles();
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    categoryEntries() {
      return this.tilesJSON && this.tilesJSON.categories
        ? Object.entries(this.tilesJSON.categories)
        : [];
    },
    tileEntries() {
      let tiles = [];
      if (this.categoryEntries && Array.isArray(this.categoryEntries)) {
        this.categoryEntries.forEach(categoryOfTiles => {
          if (
            categoryOfTiles &&
            categoryOfTiles[1] &&
            categoryOfTiles[1].tiles &&
            Array.isArray(categoryOfTiles[1].tiles)
          )
            categoryOfTiles[1].tiles.forEach(aTile => {
              tiles.push(aTile);
            });
        });
      }
      return tiles;
    },
    healthTilesDataTiles() {
      return this.heartbeatInfo &&
        this.heartbeatInfo.tiles &&
        this.heartbeatInfo.tiles.tiles
        ? this.heartbeatInfo.tiles.tiles
        : {};
    },
    healthTileKeys() {
      return this.healthTilesDataTiles
        ? Object.keys(this.healthTilesDataTiles)
        : [];
    }
  },
  methods: {
    getTiles() {
      this.$store
        .dispatch("heartbeats/getTiles", {
          heartbeat: this.heartbeat
        })
        .then(resp => {
          console.log(resp);
        })
        .catch(e => {
          console.error(e);
        });
    },
    handleAddUpdateTileModal(tileKey) {
      this.selectedTileKey = tileKey;
      this.$bvModal.show(this.addTileModalId);
    },
    handleTileAddedOrUpdated(tileInfo) {
      this.getTiles();
    }
  },
  data() {
    return {
      addToolTip: "Add New Health Tile",
      dimension: "150",
      addTileModalId: `add-tile`,
      selectedTileKey: null,
      tilesJSON
    };
  }
};
</script>

<style lang="scss" scoped>
.guide-management {
  padding: 24px;
  height: 100%;
  .tiles-card {
    border-radius: 8px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    padding: 16px;
    .personel {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .avatar {
        height: 48px;
        width: 48px;
        border-radius: 50%;
        object-fit: cover;
      }
      .profile-name {
        margin-left: 10px;
        h3 {
          font-weight: 600;
          font-size: 16px;
          line-height: 22px;
          color: #474d52;
          margin-bottom: 0;
        }
      }
    }
    .desc {
      margin-top: 15px;
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;

        /* Body */

        color: #474d52;
      }
    }
    .foot {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      & > div {
        margin-right: 12px;
        cursor: pointer;
      }
    }
  }
  .published {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #474d52;
    display: block;
    margin-top: 15px;
    @media (max-width: 991px) {
      margin-top: 34px !important;
      margin-bottom: 40px;
    }
  }
  .btn-round-fill {
    margin: 18px 0px;
  }
}
.heading__ {
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.05em;
  color: #8d99a0;
  text-transform: uppercase;
  margin-bottom: 0;
  margin-top: 10px;
}
.link__ {
  display: grid;
  grid-template-columns: 1fr 30px;
  align-items: center;
  .link {
    overflow-wrap: anywhere;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #557efb;
  }
  .ico {
    cursor: pointer;
    justify-self: flex-end;
  }
}
.skeleton-name {
  width: 80px;
  margin-top: 11px;
  margin-left: 11px;
}
.skeleton-btn {
  border-radius: 20px;
}
.skeleton-input {
  border-radius: 16px;
}
.dash-border {
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23ddddddff' stroke-width='1' stroke-dasharray='3%2c 6' stroke-dashoffset='0' stroke-linecap='butt'/%3e%3c/svg%3e");
  height: 1px;
  margin-bottom: 10px;
  margin-top: 20px;
}
.skeleton-toggle {
  height: 30px;
  width: 70px;
  margin-top: 13px;
}
.foot {
  margin-top: 15px;
  border-top: 1px solid #dddddd;
  padding-top: 10px;
}
.skeleton-save-btn {
  border-radius: 20px;
  width: 120px;
}
.upload {
  margin-bottom: 1rem;
  .upload-video {
    margin-top: 15px;
    font-family: Nunito;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    color: #8d99a0;
  }
  .upload-btn {
    margin-top: 16px;
    width: 208px;
    height: 40px;
    border-radius: 100px;
    border: none;
    outline: none !important;
    .ico {
      margin-right: 5px;
    }
    .btn-content {
      margin-top: 5px;
      font-family: Nunito;
      font-style: normal;
      font-weight: 800;
      font-size: 16px;
      line-height: 22px;
      color: #557efb;
    }
  }
  .video {
    color: #fff !important;
    background-color: #557efb !important;
  }
  .no-video {
    color: #557efb;
    background: rgba(85, 126, 251, 0.1);
  }
  .watch-video {
    margin-top: 5px;
    font-family: Nunito;
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;
  }
}
</style>
